import { CircularProgress, FormControl, FormHelperText, Grid, MenuItem, Select } from "@mui/material";
import { useGetResourcesHeadersQuery } from "../../../../../services/resourcesApi";


function ResourceHeaderDropdown({value, onChangeHandler, error}){
  const { data: resourcesHeaders, error: resourceHeaderError, isLoading: resourceHeaderLoading } = useGetResourcesHeadersQuery();

  if(resourceHeaderLoading){
    return <CircularProgress />
  }

  return (
    
      <FormControl error={error} sx={{width: "100%"}} >
        <div className="create-resouces-text" style={{marginTop: "1em"}}>
          
          {console.log(error)}
        <label
          for="resourceHeaderId"
          style={{margin: '1.25em 0 0 0', whiteSpace: "nowrap"}}
        >
          Resource Sub-Page header:{" "}
        </label>
        <Grid container direction="column">
        <Select
          variant="outlined"
          sx={{ width: '100%' }}
          value={value}
          defaultValue={"default"}
          name="resourceHeaderId"
          onChange={(e) => onChangeHandler(e.target.value)}
        >
          {resourcesHeaders.map(({ id, name }) => (
            <MenuItem value={id} key={id}>{name} </MenuItem>
          ))}
        </Select>

        <FormHelperText>{error}</FormHelperText>
        </Grid>
        </div>
      </FormControl>
  )
}

export default ResourceHeaderDropdown;